import { sriClient } from 'ReduxLoop/utils/apiConfig';

export const getGovernedSchools = async (ouHref) => {
  try {
    const governingRelations = await sriClient.getAll('/sam/organisationalunits/relations', {
      from: ouHref,
      type: 'GOVERNS',
      status: 'ACTIVE,FUTURE',
      'to.typeNot': 'SCHOOLENTITY',
    });

    const governedOuHrefs = governingRelations.map((relation) => relation.to.href);

    const ous = await sriClient.getAllHrefs(governedOuHrefs);

    const institutionNumbers = await sriClient.getAllReferencesTo(
      '/sam/organisationalunits/externalidentifiers',
      { typeIn: 'INSTITUTION_NUMBER' },
      'organisationalUnit',
      governedOuHrefs
    );

    const addresses = await sriClient.getAllReferencesTo(
      '/sam/organisationalunits/contactdetails',
      { type: 'MAIL' },
      'organisationalUnit',
      governedOuHrefs
    );

    return {
      ous,
      institutionNumbers,
      addresses,
      relations: governingRelations,
    };
  } catch (error) {
    console.error('Error fetching governed schools:', error);
    throw error;
  }
};

export const getParent = async (ouHref) => {
  try {
    const childParentRelations = await sriClient.getAll('/kathondvla/organisationalunits/relations', {
      from: ouHref,
      type: 'IS_PART_OF',
      status: 'ACTIVE,FUTURE',
    });
    console.log('childParentRelations', childParentRelations);
    if (childParentRelations.length === 0) {
      return null;
    }
    const parentOuHref = childParentRelations[0].to.href;
    return await sriClient.get(parentOuHref);
  } catch (error) {
    console.error('Error fetching parent:', error);
    throw error;
  }
}

export const getChildren = async (ouHref) => {
  try {
    const parentChildRelations = await sriClient.getAll('/kathondvla/organisationalunits/relations', {
      to: ouHref,
      type: 'IS_PART_OF',
      status: 'ACTIVE,FUTURE',
    });

    const childHrefs = parentChildRelations.map((relation) => relation.from.href);

    const ous = await sriClient.getAllHrefs(childHrefs);

    const addresses = await sriClient.getAllReferencesTo(
      '/kathondvla/organisationalunits/contactdetails',
      { type: 'MAIL' },
      'organisationalUnit',
      childHrefs
    );

    return {
      ous,
      addresses,
      relations: parentChildRelations,
    };
  } catch (error) {
    console.error('Error fetching children:', error);
    throw error;
  }
};

export const getAccountingData = async (ouHref) => {
  try {
    const domain = ouHref.split('/')[1];
    const accountingDetails = await sriClient.getAll(
      `/${domain}/organisationalunits/accountingdetails`, {
      parent: ouHref,
    });
    const externalIdentifiers = await sriClient.getAll(
      `/${domain}/organisationalunits/externalidentifiers`,
      {
        typeIn: 'GLN,COMPANY_NUMBER',
        organisationalUnit: ouHref,
      },
    );

    const childData = domain === 'sam' ?
      await getGovernedSchools(ouHref) :
      await getChildren(ouHref);

    const parent = domain === 'kathondvla' ?
      await getParent(ouHref) :
      null;

    return {
      accountingDetails,
      externalIdentifiers,
      parent,
      ...childData,
    };
  } catch (error) {
    console.error('Error fetching accounting data:', error);
    throw error;
  }
};